// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> weidner-apartment-homes-theme-belmont -> legacy-west
// Generated: 2026-10-29T23:14:19.893Z
// Counts: 0 design, 24 content, 15 slot group, 1 collection binding, 8 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Layouts</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfortable apartments in Anchorage, AK</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Legacy West</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore urban convenience at Legacy West - Target, Century 16 Theater, and Walmart are just around the corner. Unwind with a stroll through the neighborhood's green spaces or take in sweeping Chugach mountain views from your own patio or balcony. Downtown Anchorage is minutes away, with eateries, shopping, and entertainment to keep life interesting. With an easy commute and a vibrant surrounding community, you're close to everything you need and love.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime, From Anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Connect?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>A Home Design For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Your Anchorage Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Legacy West, the in-home features make life easier - enjoy an in-home washer and dryer, a cozy fireplace, and walk-in closets for smooth mornings and restful evenings. Step outside to find open pet areas, green spaces, and scenic views of the Chugach Mountain Range. Our community brings you conveniences like on-site management and maintenance, secure access, and the flexibility that makes every day brighter in Anchorage, AK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have a question or want to learn more about Legacy West? Our attentive leasing team is here to help with availability, tours, and your next steps toward living in Anchorage, AK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into roomy living at Legacy West. Our apartments for rent in Anchorage, AK, come in stunning two- and three-bedroom layouts. Picture relaxing by the fireplace, enjoying extra storage with walk-in closets, and making laundry days easy with an in-home washer and dryer. Whether you're working from home, hosting friends, or just soaking in the mountain views, you'll find flexible floor plans to fit your lifestyle and all the comforts you crave.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "Choose the Right Floor Plan For You",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself at Legacy West in Anchorage, AK. Scroll through our gallery to see apartments filled with natural light, featuring inviting kitchens and surrounded by peaceful outdoor spaces with tree-lined surroundings. See the scenic Chugach Mountain Range peeking into your window, and bring your vision for home to life in every shot. Imagine cozy nights by your fireplace and relaxing mornings on your private balcony or patio.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The neighborhood around Legacy West is your gateway to convenience and adventure in Anchorage. Step outside and find Target, Century 16 Theater, and Walmart just a quick trip away, perfect for daily errands. Enjoy Tikahtnu Commons' mix of shopping and dining, or relax on your patio with a great view of the Chugach mountains. With downtown Anchorage just minutes away, every day can bring a new experience, from local restaurants to community events and the energy of the city.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Anchorage Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>In the heart of East Anchorage</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At Legacy West, you'll settle into a home designed for comfort and flexibility. Our apartments for rent in Anchorage, AK, feature an in-home washer and dryer, cozy fireplaces, and private outdoor spaces. You'll love the little touches like walk-in closets and granite countertops. Enjoy a pet-friendly community with convenient pet stations and friendly on-site management. Explore lush surroundings with mountain views and easy access to shopping at Target, entertainment at Century 16 Theater, and nearby essentials like Walmart. Discover a living experience that puts convenience first, right at the gateway to downtown Anchorage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Legacy West your way. Schedule a live virtual or private in-person tour with our leasing team to see two- and three-bedroom apartments with large closets and in-home laundry. If you prefer, browse our virtual tours any time. We'll help you picture daily life here so you can find your fit at your own pace. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside Legacy West from anywhere and start picturing your new routine. Our virtual tours help you explore the layout, flow, and feel of the apartments and community spaces at your own pace - ideal if you're starting your search or moving from afar. Imagine unwinding in your living room, taking in mountain views, or planning your layout before you ever arrive. Experience Anchorage life virtually and easily envision yourself here.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your New Home"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.youtube": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/@WeidnerApartmentHomes"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0225-92a7-70b8-8c38-cfc3af895c48.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a light-gray sofa, wooden coffee table, wall TV, and a large window."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0225-aabb-761b-965d-27be3cd7e112.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior of an apartment living area with a small kitchen, beige walls, and carpet."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0225-971f-7558-95e8-743cb195874a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen bed, neutral decor, two nightstands, and a wooden-framed window."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-02c0-7256-b5ba-b0c34648a9c2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with brick fireplace, beige walls, carpet, and a sliding glass door to a balcony."
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0225-9272-771c-977a-17d48ed5aa50.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with oak cabinets, double sink, dishwasher, and window with blinds."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-6f47-77fb-989e-f63bc12cede1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Westchester Lagoon nature trail, a scenic waterfront recreation spot near Legacy West in Anchorage."
      }
    }
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-8347-753f-a9b7-7fadd0d8fd1c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Chanshtnu Muldoon Park, a family-friendly Anchorage park with a playground and picnic areas."
      }
    }
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-5f7a-7603-8dcb-35408a00d700.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Alaska Native Heritage Center, a cultural landmark near the Legacy West community in Anchorage."
      }
    }
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-626c-767a-a35d-da111e4e72c9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The Anchorage Museum, a downtown landmark showcasing Alaskan art, history, and science exhibits."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": [
      "ec_dce1d3ea22e9ab9cb863062a"
    ],
    "orderedIds": [
      "ec_dd51be3e487ad2726a2598ad",
      "ec_59dd6f6e8598f10741aa9feb",
      "ec_db0bc62b425a98236159e30b",
      "ec_f1cc846d3bd3b979033366b1",
      "ec_31f404d2bb994f8e6aecc9fc",
      "ec_d980a495cad35ef178284868",
      "ec_fbd779ba8cb0bac7111cf62b",
      "ec_ea8ade240199ea0a6135262c",
      "ec_fd5c302a4ab1318eb064f0e5",
      "ec_4d591afe664d5496b0b46b0c",
      "ec_6b3258da5728a313b0d5ebd2",
      "ec_97ecc1c10df58254f5fbeebc",
      "ec_f0755ec69905779f8c79af94",
      "ec_dce1d3ea22e9ab9cb863062a",
      "ec_b9e8723573493cf7d0667539",
      "ec_e587a16e4884847326b5c4bc",
      "ec_17cab1c41a4da3115240d970",
      "ec_76ffada405a36c25d66160f7",
      "ec_71d5151c3474244d77225180",
      "ec_ec5cfcfe3a6086c1d14b3c29",
      "ec_55291741fda12370a339982a",
      "ec_618417438d2edba4b9fdc9ef"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
